var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 506.1",
    style: {
      enableBackground: "new 0 0 512 506.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5,505.8c-12.6,0.7-24.9-3.4-34.4-11.6c-18.8-18.9-18.8-49.5,0-68.4L425.8,14.1c19.6-18.3,50.2-17.3,68.5,2.3 c16.5,17.7,17.5,44.9,2.3,63.7L82.5,494.2C73.1,502.3,60.9,506.5,48.5,505.8L48.5,505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.8,505.8c-12.7-0.1-24.9-5.1-33.9-14.1L14.1,80C-3.3,59.7-1,29.1,19.4,11.7c18.2-15.5,44.9-15.5,63.1,0l414.2,411.7 c19.6,18.3,20.6,49,2.3,68.5c-0.7,0.8-1.5,1.5-2.3,2.3C486.5,503,473.2,507.2,459.8,505.8L459.8,505.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7249c397c2b34910fdebaab1543cd6a2.svg";
export { ForwardRef as ReactComponent };